export const ACCESS_TOKEN_COOKIE = "access_token";
export const REFRESH_TOKEN_COOKIE = "refresh_token";

export const QUOTE_TOKEN_ADDRESSES = [
  "So11111111111111111111111111111111111111112",
  "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
  "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
  "USD1ttGY1N17NEEHLmELoaybftRBUSErhqYiQzvEmuB",
];

export const WRAPPED_TOKEN_ADDRESS =
  "So11111111111111111111111111111111111111112";

export const USDC_TOKEN_ADDRESS =
  "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";
export const USD1_TOKEN_ADDRESS = "USD1ttGY1N17NEEHLmELoaybftRBUSErhqYiQzvEmuB";

export const DEFAULT_TRACKED_GROUP_EMOJI = "💰";
export const DEFAULT_TRACKED_WALLET_EMOJI = "🔥";
export const DEFAULT_TRACKED_SMART_NOTIFICATION_EMOJI = "🔥";

export const LOW_LIQUIDITY_THRESHOLD = 2000;
